import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const carListRequest = createAction(types.CAR_LIST_REQUEST);
export const carListSuccess = createAction(types.CAR_LIST_SUCCESS);
export const carListFailure = createAction(types.CAR_LIST_FAILURE);

export const getFilteredCarsRequest = createAction(types.FILTER_CARS_REQUEST);
export const getFilteredCarsSuccess = createAction(types.FILTER_CARS_SUCCESS);
export const getFilteredCarsFailure = createAction(types.FILTER_CARS_FAILURE);

export default {
  carListRequest,
  carListSuccess,
  carListFailure,
  getFilteredCarsRequest,
  getFilteredCarsSuccess,
  getFilteredCarsFailure,
};
